export default "__VITE_ASSET__DrGPxEj4__"